/**
 * Application Role Definitions
 * @enum {string}
 *
 * ADMINISTRATIVE:
 * - SupportAdmin: Full system access
 * - PartnerAdmin: Manages partner relationships
 * - IndustryAdmin: Oversees industry-specific settings
 *
 * SALES:
 * - SalesRep: Field sales representative
 * - Account Manager: Client account management
 * - viewESales: Read-only sales data access
 *
 * MANAGEMENT:
 * - RegionalManager: Oversees multiple branches
 * - Sub Branch Manager: Manages sub-branches
 * - IndustryManager: Industry-specific management
 */
export const ROLE_CATEGORIES = {
  ADMINISTRATIVE: ["SupportAdmin", "PartnerAdmin", "IndustryAdmin"],
  SALES: ["SalesRep", "Account Manager", "viewESales"],
  MANAGEMENT: ["RegionalManager", "Sub Branch Manager", "IndustryManager"],
  OPERATIONS: ["Company", "Dealers", "Branch", "GroupBranchList", "Group"],
  TECHNICAL: ["RegionalEngineer"],
  CUSTOMER_FACING: ["POS Owner", "POS Bank", "Customer"],
  TEAMS: ["Team", "IndustryGroup"],
};

// Flat array of all allowed roles
export const ALLOWED_ROLES = Object.values(ROLE_CATEGORIES).flat();

// Role to route mappings
export const ROLE_REDIRECTS = {
  SupportAdmin: "company-list",
  Company: "dashboard",
  // Add other specific role routes here
  default: "dashboard", // Fallback route
};
